import moment from 'moment'
import { columnHelper } from '../../../iba-components/Table'

const Header = (text) => {
    return <span>{text}</span>
}

export const getBaseThemeColumnList = (t) => [
    columnHelper.accessor('themeid', {
        header: Header(t('theme.modal.column.themeId')),
        size: 80
    }),
    columnHelper.accessor('category1', {
        header: Header(t('theme.modal.column.category1'))
    }),
    columnHelper.accessor('category2', {
        header: Header(t('theme.modal.column.category2'))
    }),
    columnHelper.accessor('themename', {
        header: Header(t('theme.modal.column.themeName')),
        size: 300
    })
]

export const getClientThemeColumnList = (t) => [
    columnHelper.accessor('name', {
        header: Header(t('theme.baseTheme.column.baseThemeName')),
        size: 300
    }),
    columnHelper.accessor('created_date', {
        header: Header(t('theme.baseTheme.column.createdDate')),
        cell: (props) => (props.getValue() ? moment(props.getValue()).format('YYYY-MM-DD') : '')
    }),
    columnHelper.accessor('create_by', {
        header: Header(t('theme.baseTheme.column.createdBy'))
    })
]

export const getDuplicateCheckColumnList = (t) => [
    columnHelper.accessor('theme_name', {
        header: Header(t('theme.modal.themeName')),
        size: 300
    }),
    columnHelper.accessor('baseThemes', {
        header: Header(t('theme.modal.baseThemeBelonging'))
    })
]
